import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Loader from '../../Components/Loader/Loader';
import { serviceConsumer } from '../../network/ServiceConsumer';
import { handleLogoUpload, handlePdfUpload } from '../../helper/handleUploads';

// Oireachtas About tab — reuses the live feis About layout/classes (uploadeDIv
// file cards, EventDateOrg header, input-text-area + counter). Plain React.
// No award settings for Oireachtas. Saves to PUT /oireachtas/:id.
const AboutFies = (props) => {
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState('');
  const [logoUrl, setLogoUrl] = useState('');
  const [logoName, setLogoName] = useState('');
  const [syllabusUrl, setSyllabusUrl] = useState('');
  const [imgError, setImgErr] = useState('');
  const [sylError, setSylErr] = useState('');
  const [, setEdit] = useState(false);
  const EventID = localStorage.getItem('ID');

  useEffect(() => {
    (async () => {
      if (!EventID) return;
      try {
        setLoading(true);
        const res = await serviceConsumer('GET', `${process.env.REACT_APP_BASE_URL}/oireachtas/${EventID}`);
        const ev = res.event;
        if (ev) { setText(ev.description || ''); setLogoUrl(ev.logo || ''); setLogoName(ev.logoName || ''); setSyllabusUrl(ev.syllabus_file || ''); }
      } catch (e) { /* new */ } finally { setLoading(false); }
    })();
  }, [EventID]);

  const onLogo = (e) => handleLogoUpload(e, setLogoName, setLogoUrl, setLoading, setImgErr, setEdit);
  const onPdf = (e) => handlePdfUpload(e, setSyllabusUrl, setSylErr, setLoading, setEdit);

  const submit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await serviceConsumer('PUT', `${process.env.REACT_APP_BASE_URL}/oireachtas/${EventID}`,
        { description: text, logo: logoUrl, logoName, syllabus_file: syllabusUrl, page: 5 });
      if (res.success) {
        localStorage.setItem('TAB', 6);
        if (Number(localStorage.getItem('page')) < 5) localStorage.setItem('page', 5);
        setTimeout(() => props.setValue('6'), 200);
      }
    } catch (err) { toast.error(err?.message || 'Failed to save.'); }
    finally { setLoading(false); }
  };

  const uploadBtn = (onChange, accept) => (
    <label className="plusIconbtn" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, border: '1.5px solid #68ad3f', color: '#588f36', background: '#fff', borderRadius: 10, padding: '8px 16px', cursor: 'pointer', fontWeight: 600 }}>
      + Upload File
      <input type="file" accept={accept} onChange={onChange} style={{ display: 'none' }} />
    </label>
  );

  const fileCard = (name, onDelete) => (
    <div className="uploadeDIv d-flex align-items-center py-2">
      <div className="fileIcon col-2 d-flex justify-content-center"><AttachFileIcon /></div>
      <div className="col-8 flex-grow-1" style={{ wordBreak: 'break-word' }}>{name}</div>
      <div className="pdfDlticon col-2 d-flex justify-content-center"><DeleteOutlineIcon onClick={onDelete} style={{ cursor: 'pointer' }} /></div>
    </div>
  );

  return (
    <div>
      {loading && <Loader />}
      {!loading && (
        <form className="form form-label-right" autoComplete="off" onSubmit={submit} style={{ maxWidth: 720 }}>
          <div className="detailsHeaders">
            <h4 className="eventPage">About event</h4>
            <p className="eventDescription">Complete the event description.</p>
          </div>

          <label className="label-head-org-file mt-3">Logo:</label><br />
          {logoUrl ? fileCard(logoName ? `Logo_Oireachtas_${logoName}` : 'Logo', () => { setLogoUrl(''); setLogoName(''); }) : uploadBtn(onLogo, 'image/*')}
          <div className="error mt-2">{imgError}</div>

          <label className="label-head-org-file mt-3">Syllabus File:</label><br />
          {syllabusUrl ? fileCard('Syllabus PDF', () => setSyllabusUrl('')) : uploadBtn(onPdf, 'application/pdf')}
          <div className="error mt-2">{sylError}</div>

          <div><h3 className="EventDateOrg">Description</h3></div>
          <div className="input-control">
            <label className="label-head-org-file">Description:</label><br />
            <textarea className="input-text-area" placeholder="Add Description" value={text} onChange={(e) => setText(e.target.value)} />
          </div>
          <div className="input-text-area-length">{!text?.length ? 500 : 500 - (text?.trim()?.split(/\s+/)?.length || 0)}</div>

          <div className="mt-3 mb-5">
            <button className="filled" type="submit">Next</button>
          </div>
        </form>
      )}
      <ToastContainer />
    </div>
  );
};

export default AboutFies;
